import { render, staticRenderFns } from "./SalaryInquiries.vue?vue&type=template&id=038e4b4e&"
import script from "./SalaryInquiries.vue?vue&type=script&lang=js&"
export * from "./SalaryInquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports